import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class VimeoApiService {

  constructor(private readonly http: HttpClient) { }

  getThumbnailVimeo(id) {
    return this.http.get('https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/' + id);
  }
}
